import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { cashService } from '../services/cashService';
import { CashTransactionCreatePayload } from '../types';

export function useCashBalance() {
  return useQuery({
    queryKey: ['cash', 'balance'],
    queryFn: () => cashService.getBalance(),
  });
}

export function useCashTransactions(page = 1, perPage = 20, transactionType?: string) {
  return useQuery({
    queryKey: ['cash', 'transactions', page, perPage, transactionType],
    queryFn: () => cashService.getTransactions(page, perPage, transactionType),
  });
}

export function useCreateCashTransaction() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: CashTransactionCreatePayload) => cashService.createTransaction(data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['cash'] });
      qc.invalidateQueries({ queryKey: ['dashboard'] });
    },
  });
}

export function useDeleteCashTransaction() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => cashService.deleteTransaction(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['cash'] });
      qc.invalidateQueries({ queryKey: ['dashboard'] });
    },
  });
}
